"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Authentication_1 = __importDefault(require("@lwt-common/authentication/build/Authentication"));
var APP_ID_PLATFORM_UI = "ul";
var TOKEN_KEY_NAME = "lwaToken";
var SESSION_CHECK_KEY_NAME = "lwaSessionCheck";
var SESSION_CHECK_KEY_MAX_AGE = 365 * 24 * 60 * 60 * 1000; // 365 days in milliseconds.
var getTokenCookieName = function (lwDomain) {
    return "".concat(TOKEN_KEY_NAME, "@@").concat(lwDomain);
};
var getSessionCheckCookieName = function (lwDomain) {
    return "".concat(SESSION_CHECK_KEY_NAME, "@@").concat(lwDomain);
};
var buildUrl = function (lwDomain, prefix) {
    return "https://".concat(prefix, ".").concat(lwDomain);
};
var buildProductLaunchUrl = function (domain, connection, luParamValue) {
    var url;
    if (connection.platformClient && connection.clientId === null) {
        var platformClientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(platformClientConnection.appId);
    }
    else if (connection.platformClient) {
        var platformClientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(platformClientConnection.appId, "&ac=").concat(platformClientConnection.clientId);
    }
    else if (connection.clientId != null) {
        var clientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(clientConnection.appId, "&c=").concat(clientConnection.clientId, "&m=").concat(clientConnection.memberId);
    }
    else if (connection.userId != null) {
        var userConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(userConnection.appId, "&u=").concat(userConnection.userId);
    }
    else {
        url = "".concat(domain, "/product/launch?a=").concat(connection.appId);
    }
    if (luParamValue) {
        url = "".concat(url, "&lu=").concat(luParamValue);
    }
    return url;
};
var isPlatformUiAppId = function (appId) {
    return appId === APP_ID_PLATFORM_UI;
};
var isLwolfDomain = function (lwDomain) {
    return window.location.hostname.includes(lwDomain);
};
var getStoredToken = function (lwDomain, appId) {
    var _a, _b;
    var token = (_a = sessionStorage.getItem(TOKEN_KEY_NAME)) !== null && _a !== void 0 ? _a : undefined;
    if (!token) {
        if (isLwolfDomain(lwDomain)) {
            token = getTokenFromCookie(lwDomain);
        }
        else {
            token = (_b = localStorage.getItem(TOKEN_KEY_NAME)) !== null && _b !== void 0 ? _b : undefined;
        }
        if (token) {
            storeToken(lwDomain, token, appId);
        }
    }
    return token;
};
var storeToken = function (lwDomain, token, appId) {
    var _a, _b, _c;
    if (token) {
        var parsedToken = Authentication_1.default.parseToken(token);
        var sessionCheckExpires = getSessionCheckExpires();
        // If the current application uses connections (not clients) from the LWA, set the token in session storage.
        if (!!(((_b = (_a = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim()) === null || _a === void 0 ? void 0 : _a.getAppsClaim()) !== null && _b !== void 0 ? _b : {})[appId !== null && appId !== void 0 ? appId : ''])) {
            sessionStorage.setItem(TOKEN_KEY_NAME, token);
        }
        if (isLwolfDomain(lwDomain)) {
            var tokenExpirationTime = (_c = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getExpirationTime()) !== null && _c !== void 0 ? _c : 0;
            var tokenExpires = new Date(tokenExpirationTime * 1000).toUTCString();
            document.cookie = "".concat(getTokenCookieName(lwDomain), "=").concat(token, ";Domain=.").concat(lwDomain, ";Secure;SameSite=Strict;Expires=").concat(tokenExpires, ";Path=/");
            document.cookie = "".concat(getSessionCheckCookieName(lwDomain), "=true;Domain=.").concat(lwDomain, ";Secure;SameSite=Strict;Expires=").concat(sessionCheckExpires, ";Path=/");
        }
        else {
            localStorage.setItem(TOKEN_KEY_NAME, token);
        }
    }
    else {
        sessionStorage.removeItem(TOKEN_KEY_NAME);
        if (isLwolfDomain(lwDomain)) {
            document.cookie = "".concat(getTokenCookieName(lwDomain), "=;Domain=.").concat(lwDomain, ";Expires=Thu, 01 Jan 1970 00:00:00 UTC;Path=/");
            document.cookie = "".concat(getSessionCheckCookieName(lwDomain), "=;Domain=.").concat(lwDomain, ";Expires=Thu, 01 Jan 1970 00:00:00 UTC;Path=/");
        }
        localStorage.removeItem(TOKEN_KEY_NAME);
        // We have left this in to clear unneeded data from local-storage for users already having sessions open in the browser.
        // We can remove this code later.
        localStorage.removeItem(SESSION_CHECK_KEY_NAME);
        localStorage.removeItem("lwaSessionCheckExpires");
    }
};
var getSessionCheckExpires = function () {
    return new Date(Date.now() + SESSION_CHECK_KEY_MAX_AGE).toUTCString();
};
var getTokenFromCookie = function (lwDomain) {
    var _a;
    var cookies = document.cookie.split("; ");
    var tokenCookie = (_a = document.cookie.split("; ")
        .find(function (row) { return row.startsWith("".concat(getTokenCookieName(lwDomain), "=")); })) === null || _a === void 0 ? void 0 : _a.split("=")[1];
    return tokenCookie;
};
var isTokenExpired = function (token) {
    var _a, _b;
    var tokenExpirationTime = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getExpirationTime()) !== null && _b !== void 0 ? _b : 0;
    return tokenExpirationTime * 1000 < Date.now();
};
var getCompareFunction = function (field, options) {
    if (options === void 0) { options = {}; }
    return function (a, b) {
        var aV = a[field];
        var bV = b[field];
        if (typeof aV !== typeof bV) {
            throw 'Type mismatch when doing comparison.';
        }
        var ignoreCase = options.ignoreCase;
        if (typeof aV === 'string' && typeof bV === 'string') {
            var string1 = aV;
            var string2 = bV;
            if (ignoreCase) {
                string1 = string1.toLowerCase();
                string2 = string2.toLowerCase();
            }
            return string1.localeCompare(string2);
        }
        if (aV === bV) {
            return 0;
        }
        else {
            return aV < bV ? -1 : 1;
        }
    };
};
var PlatformService = /** @class */ (function () {
    function PlatformService(lwDomain, platformUrlOverride, token, appId, lwaOnly, includeOriginInRedirects, beforeSignOutCallback, luParamSupplier) {
        this.cachedClients = {};
        this.lwDomain = lwDomain;
        this.platformUrlOverride = platformUrlOverride;
        this.token = token;
        this.appId = appId;
        this.lwaOnly = lwaOnly;
        this.includeOriginInRedirects = includeOriginInRedirects;
        this.beforeSignOutCallback = beforeSignOutCallback;
        this.luParamSupplier = luParamSupplier;
        this.cachedClients = {};
    }
    PlatformService.initialize = function (_a) {
        var _b;
        var lwDomain = _a.lwDomain, platformUrlOverride = _a.platformUrlOverride, token = _a.token, appId = _a.appId, forceEndLwaSession = _a.forceEndLwaSession, beforeSignOutCallback = _a.beforeSignOutCallback, luParamSupplier = _a.luParamSupplier, _c = _a.lwaOnly, lwaOnly = _c === void 0 ? false : _c, _d = _a.includeOriginInRedirects, includeOriginInRedirects = _d === void 0 ? false : _d;
        return __awaiter(this, void 0, void 0, function () {
            var doLwaSessionCheck, platformService, authenticationApiUrl, sessionStatusResponse, isAuthenticated;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!lwDomain) {
                            throw Error('lwDomain is required.');
                        }
                        if (forceEndLwaSession) {
                            if (lwaOnly) {
                                throw Error('forceEndLwaSession cannot be true for lwaOnly mode.');
                            }
                            token = undefined;
                            storeToken(lwDomain, token, appId);
                        }
                        if (token) {
                            // If a token is passed in, save it to our storage chain.
                            storeToken(lwDomain, token, appId);
                            doLwaSessionCheck = true;
                        }
                        else {
                            // If a token is NOT passed in, try reading it from the storage chain.
                            token = getStoredToken(lwDomain, appId);
                            if (isLwolfDomain(lwDomain)) {
                                // IF the token we got was from the cookie, we use the cookie to get the session-check variable as well.
                                doLwaSessionCheck = ((_b = document.cookie
                                    .split("; ")
                                    .find(function (row) { return row.startsWith("".concat(getSessionCheckCookieName(lwDomain), "=")); })) === null || _b === void 0 ? void 0 : _b.split("=")[1]) !== undefined;
                            }
                            else {
                                doLwaSessionCheck = !!token;
                            }
                        }
                        platformService = new PlatformService(lwDomain, platformUrlOverride, token, appId, lwaOnly, includeOriginInRedirects, beforeSignOutCallback, luParamSupplier);
                        doLwaSessionCheck = doLwaSessionCheck || lwaOnly;
                        if (!(doLwaSessionCheck && !isPlatformUiAppId(appId))) return [3 /*break*/, 3];
                        if (!(!token || isTokenExpired(token))) return [3 /*break*/, 1];
                        platformService.tryRelaunch();
                        return [3 /*break*/, 3];
                    case 1:
                        authenticationApiUrl = platformService.getAuthenticationApiUrl();
                        return [4 /*yield*/, fetch("".concat(authenticationApiUrl, "/v1/user-session"), {
                                headers: {
                                    'Authorization': "Bearer ".concat(token)
                                }
                            })];
                    case 2:
                        sessionStatusResponse = _e.sent();
                        isAuthenticated = sessionStatusResponse.ok || sessionStatusResponse.status !== 404;
                        if (!isAuthenticated) {
                            platformService.tryRelaunch();
                        }
                        _e.label = 3;
                    case 3: return [4 /*yield*/, platformService.getAppData()];
                    case 4:
                        _e.sent();
                        return [2 /*return*/, platformService];
                }
            });
        });
    };
    PlatformService.prototype.getPlatformUrl = function () {
        var _a;
        return (_a = this.platformUrlOverride) !== null && _a !== void 0 ? _a : buildUrl(this.lwDomain, "platform");
    };
    PlatformService.prototype.getAuthenticationApiUrl = function () {
        return buildUrl(this.lwDomain, "authentication.api");
    };
    PlatformService.prototype.getPlatformApiUrl = function () {
        return buildUrl(this.lwDomain, "platform.api");
    };
    PlatformService.prototype.tryRelaunch = function (forceLogout) {
        if (forceLogout === void 0) { forceLogout = false; }
        storeToken(this.lwDomain, undefined, this.appId);
        if (this.beforeSignOutCallback) {
            this.beforeSignOutCallback();
        }
        var url;
        if (forceLogout) {
            url = "".concat(this.getPlatformUrl(), "/logout");
        }
        else if (this.appId && !isPlatformUiAppId(this.appId)) {
            var userUrlEncoded = encodeURIComponent(this.includeOriginInRedirects ? window.location.href : (window.location.pathname + window.location.search));
            url = "".concat(this.getPlatformUrl(), "/product/launch?a=").concat(this.appId, "&r=").concat(userUrlEncoded);
            if (this.luParamSupplier) {
                var luParamValue = this.luParamSupplier();
                if (luParamValue) {
                    url = "".concat(url, "&lu=").concat(luParamValue);
                }
            }
        }
        else {
            url = "".concat(this.getPlatformUrl());
        }
        window.location.assign(url);
    };
    PlatformService.prototype.getAppData = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = true; }
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        if (useCache && this.cachedAppData !== undefined) {
            return Promise.resolve(__spreadArray([], this.cachedAppData, true));
        }
        return fetch("".concat(this.getPlatformApiUrl(), "/v1/unified-login-configs"), {
            headers: {
                'Authorization': "Bearer ".concat(token)
            }
        }).then(function (response) {
            if (!response.ok) {
                if (response.status === 401) {
                    if (!isPlatformUiAppId(_this.appId)) {
                        _this.tryRelaunch();
                    }
                    else {
                        return [];
                    }
                }
                else {
                    throw new Error('Invalid response from platform API');
                }
            }
            else {
                return response.json().then(function (responseJson) {
                    var _a;
                    _this.cachedAppData = __spreadArray([], responseJson, true);
                    var currentAppConfig = (_a = _this.cachedAppData.find(function (config) { return config.id === _this.appId; })) === null || _a === void 0 ? void 0 : _a.config;
                    _this.appName = currentAppConfig === null || currentAppConfig === void 0 ? void 0 : currentAppConfig.name;
                    return responseJson;
                });
            }
        }).catch(function (err) {
            throw err;
        });
    };
    PlatformService.prototype.getLwaClients = function (useCache) {
        var _this = this;
        var _a, _b;
        if (useCache === void 0) { useCache = false; }
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        if (useCache && this.cachedLwaClients !== undefined) {
            return Promise.resolve(this.cachedLwaClients);
        }
        var userId = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getUserId();
        return fetch("".concat(this.getAuthenticationApiUrl(), "/v1/users/").concat(userId, "/clients"), {
            headers: {
                'Authorization': "Bearer ".concat(token)
            }
        }).then(function (response) {
            if (!response.ok) {
                if (response.status === 401) {
                    if (!isPlatformUiAppId(_this.appId)) {
                        _this.tryRelaunch();
                    }
                    else {
                        return [];
                    }
                }
                else {
                    throw new Error('Invalid response from authentication API');
                }
            }
            else {
                return response.json().then(function (responseJson) {
                    _this.cachedLwaClients = __spreadArray([], responseJson, true);
                    return responseJson;
                });
            }
        }).catch(function (err) {
            throw err;
        });
    };
    /**
     * @deprecated since version 3.12.0
     *
     * This function is deprecated and will be removed at some point in the future. Use the {@link PlatformService#getClientsInToken} function instead.
     */
    PlatformService.prototype.getClients = function () {
        return this.getClientsInToken();
    };
    PlatformService.prototype.getClientsInToken = function () {
        var _a, _b, _c;
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        var clients = (_c = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getClients()) !== null && _c !== void 0 ? _c : [];
        return Promise.resolve(clients);
    };
    PlatformService.prototype.getClientsSummary = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = false; }
        var doGetClientsSummary = function () { return __awaiter(_this, void 0, void 0, function () {
            var token, getPlatformClient, clients, lwaClients, _i, lwaClients_1, lwaClient, response, responseJson, platformClient, clientsSummary;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        getPlatformClient = function (clientId) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fetch("".concat(this.getPlatformApiUrl(), "/v1/clients/").concat(clientId), {
                                            headers: {
                                                'Authorization': "Bearer ".concat(token)
                                            }
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        clients = [];
                        if (!(useCache && this.cachedClients)) return [3 /*break*/, 1];
                        (_a = Object.keys(this.cachedClients)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                            clients.push(_this.cachedClients[key]);
                        });
                        return [3 /*break*/, 8];
                    case 1: return [4 /*yield*/, this.getLwaClients(useCache)];
                    case 2:
                        lwaClients = _b.sent();
                        _i = 0, lwaClients_1 = lwaClients;
                        _b.label = 3;
                    case 3:
                        if (!(_i < lwaClients_1.length)) return [3 /*break*/, 8];
                        lwaClient = lwaClients_1[_i];
                        if (!token) {
                            token = this.validateAndGetToken();
                        }
                        return [4 /*yield*/, getPlatformClient(lwaClient.clientId)];
                    case 4:
                        response = _b.sent();
                        if (!!response.ok) return [3 /*break*/, 5];
                        if (response.status === 401) {
                            if (!isPlatformUiAppId(this.appId)) {
                                this.tryRelaunch();
                                return [2 /*return*/, Promise.resolve([])];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve([])];
                            }
                        }
                        else {
                            return [2 /*return*/, Promise.reject(new Error('Invalid response from platform API'))];
                        }
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, response.json()];
                    case 6:
                        responseJson = _b.sent();
                        platformClient = responseJson;
                        clients.push(platformClient);
                        _b.label = 7;
                    case 7:
                        _i++;
                        return [3 /*break*/, 3];
                    case 8:
                        clientsSummary = clients.map(function (c) {
                            var clientSummary = {
                                id: c.id,
                                name: c.name,
                                type: c.type
                            };
                            return clientSummary;
                        });
                        return [2 /*return*/, Promise.resolve(clientsSummary)];
                }
            });
        }); };
        return doGetClientsSummary();
    };
    PlatformService.prototype.getClientsAsConnections = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = false; }
        var token;
        var getPlatformClient = function (clientId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(this.getPlatformApiUrl(), "/v1/clients/").concat(clientId), {
                            headers: {
                                'Authorization': "Bearer ".concat(token)
                            }
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        var mapClients = function () { return __awaiter(_this, void 0, void 0, function () {
            var clients, connections, clientsJustFetched, _i, clients_1, client, clientName, platformClient, response, responseJson, platformClient, _loop_1, this_1, _a, _b, application, twConnections, twNonUserConnections, twUserConnection, userTypeClient, userTypeClientExternalSystems_1, removeTwUserConnection, _loop_2, _c, twNonUserConnections_1, twNonUserConnection, state_1;
            var _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, this.getLwaClients(useCache)];
                    case 1:
                        clients = _g.sent();
                        connections = [];
                        clientsJustFetched = {};
                        _i = 0, clients_1 = clients;
                        _g.label = 2;
                    case 2:
                        if (!(_i < clients_1.length)) return [3 /*break*/, 12];
                        client = clients_1[_i];
                        clientName = '';
                        if (!((useCache && this.cachedClients[client.clientId])
                            || clientsJustFetched[client.clientId])) return [3 /*break*/, 3];
                        clientName = this.cachedClients[client.clientId].name;
                        if (!clientName) {
                            platformClient = clientsJustFetched[client.clientId];
                            clientName = platformClient.name;
                            this.cachedClients[client.clientId] = platformClient;
                        }
                        return [3 /*break*/, 7];
                    case 3:
                        if (!token) {
                            token = this.validateAndGetToken();
                        }
                        return [4 /*yield*/, getPlatformClient(client.clientId)];
                    case 4:
                        response = _g.sent();
                        if (!!response.ok) return [3 /*break*/, 5];
                        if (response.status === 401) {
                            if (!isPlatformUiAppId(this.appId)) {
                                this.tryRelaunch();
                                return [2 /*return*/, Promise.resolve([])];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve([])];
                            }
                        }
                        else {
                            return [2 /*return*/, Promise.reject(new Error('Invalid response from platform API'))];
                        }
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, response.json()];
                    case 6:
                        responseJson = _g.sent();
                        platformClient = responseJson;
                        clientName = platformClient.name;
                        this.cachedClients[client.clientId] = platformClient;
                        clientsJustFetched[client.clientId] = platformClient;
                        _g.label = 7;
                    case 7:
                        _loop_1 = function (application) {
                            var applicationCode, appData, collapseItems, appExist, connection;
                            return __generator(this, function (_h) {
                                switch (_h.label) {
                                    case 0:
                                        applicationCode = application.code;
                                        return [4 /*yield*/, this_1.getAppData(useCache)];
                                    case 1:
                                        appData = _h.sent();
                                        collapseItems = (_f = (_e = appData.find(function (config) { return config.id === applicationCode; })) === null || _e === void 0 ? void 0 : _e.config.collapseItems) !== null && _f !== void 0 ? _f : false;
                                        appExist = connections.find(function (connection) { return connection.appId === applicationCode; });
                                        if (collapseItems && appExist)
                                            return [2 /*return*/, "continue"];
                                        connection = {
                                            appId: applicationCode,
                                            name: clientName,
                                            clientId: !collapseItems ? client.clientId : null,
                                            platformClient: true
                                        };
                                        connections.push(connection);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a = 0, _b = (_d = client.applications) !== null && _d !== void 0 ? _d : [];
                        _g.label = 8;
                    case 8:
                        if (!(_a < _b.length)) return [3 /*break*/, 11];
                        application = _b[_a];
                        return [5 /*yield**/, _loop_1(application)];
                    case 9:
                        _g.sent();
                        _g.label = 10;
                    case 10:
                        _a++;
                        return [3 /*break*/, 8];
                    case 11:
                        _i++;
                        return [3 /*break*/, 2];
                    case 12:
                        twConnections = connections.filter(function (c) { return c.appId === 'tw'; });
                        twNonUserConnections = twConnections.filter(function (conn) {
                            var client = clients.find(function (c) { return c.clientId === conn.clientId; });
                            return (client === null || client === void 0 ? void 0 : client.clientType) !== 'User';
                        });
                        twUserConnection = twConnections.find(function (conn) {
                            var client = clients.find(function (c) { return c.clientId === conn.clientId; });
                            return (client === null || client === void 0 ? void 0 : client.clientType) === 'User';
                        });
                        if (twUserConnection) {
                            userTypeClient = clients
                                .find(function (c) { return c.clientId === twUserConnection.clientId; });
                            userTypeClientExternalSystems_1 = userTypeClient.externalSystems;
                            if (userTypeClientExternalSystems_1
                                && userTypeClientExternalSystems_1.length > 0
                                && twNonUserConnections.length > 0) {
                                removeTwUserConnection = false;
                                _loop_2 = function (twNonUserConnection) {
                                    if (removeTwUserConnection) {
                                        return "break";
                                    }
                                    var client = clients
                                        .filter(function (c) { return c.clientId === twNonUserConnection.clientId; })[0];
                                    var userExternalSystems = client.externalSystems;
                                    var _loop_3 = function (esCode) {
                                        var matchingExternalSystemInfoFound = userExternalSystems
                                            ? userExternalSystems.some(function (ues) {
                                                var _a;
                                                return ues.code === esCode
                                                    && ues.number === ((_a = userTypeClientExternalSystems_1.find(function (ex) { return ex.code === esCode; })) === null || _a === void 0 ? void 0 : _a.number);
                                            })
                                            : false;
                                        if (matchingExternalSystemInfoFound) {
                                            removeTwUserConnection = true;
                                            return "break";
                                        }
                                    };
                                    for (var esCode in userTypeClientExternalSystems_1) {
                                        var state_2 = _loop_3(esCode);
                                        if (state_2 === "break")
                                            break;
                                    }
                                };
                                for (_c = 0, twNonUserConnections_1 = twNonUserConnections; _c < twNonUserConnections_1.length; _c++) {
                                    twNonUserConnection = twNonUserConnections_1[_c];
                                    state_1 = _loop_2(twNonUserConnection);
                                    if (state_1 === "break")
                                        break;
                                }
                                if (removeTwUserConnection) {
                                    connections = connections.filter(function (conn) { return conn.appId !== 'tw'
                                        || conn.clientId !== twUserConnection.clientId; });
                                }
                            }
                        }
                        return [2 /*return*/, Promise.resolve(connections)];
                }
            });
        }); };
        return mapClients();
    };
    PlatformService.prototype.getConnections = function (useCache, includePlatformClients) {
        var _this = this;
        var _a, _b;
        if (useCache === void 0) { useCache = true; }
        if (includePlatformClients === void 0) { includePlatformClients = true; }
        var token = this.validateAndGetToken();
        if (!token) {
            return Promise.resolve([]);
        }
        if (useCache && this.cachedConnections !== undefined) {
            return Promise.resolve(includePlatformClients
                ? this.getClientsAsConnections(useCache).then(function (clientsAsConnections) {
                    var _a;
                    return __spreadArray(__spreadArray([], (_a = _this.cachedConnections) !== null && _a !== void 0 ? _a : [], true), clientsAsConnections, true);
                })
                    .catch(function (err) {
                    throw err;
                })
                : __spreadArray([], this.cachedConnections, true));
        }
        var userId = (_b = (_a = Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getUserId();
        return fetch("".concat(this.getAuthenticationApiUrl(), "/v1/users/").concat(userId, "/connections"), {
            headers: {
                'Authorization': "Bearer ".concat(token)
            }
        }).then(function (response) {
            if (!response.ok) {
                if (response.status === 401) {
                    if (!isPlatformUiAppId(_this.appId)) {
                        _this.tryRelaunch();
                    }
                    else {
                        return [];
                    }
                }
                else {
                    throw new Error('Invalid response from authentication API');
                }
            }
            else {
                return response.json().then(function (responseJson) {
                    _this.cachedConnections = __spreadArray([], responseJson, true);
                    return includePlatformClients
                        ? _this.getClientsAsConnections(useCache).then(function (clientsAsConnections) {
                            return __spreadArray(__spreadArray([], responseJson, true), clientsAsConnections, true);
                        }).catch(function (err) {
                            throw err;
                        })
                        : responseJson;
                });
            }
        }).catch(function (err) {
            throw err;
        });
    };
    PlatformService.prototype.getAppSections = function (useCache) {
        var _this = this;
        if (useCache === void 0) { useCache = true; }
        return this.getConnections(useCache, true)
            .then(function (connections) { return __awaiter(_this, void 0, void 0, function () {
            var appData, sectionItems, appMap, namesMap, _loop_4, this_2, _i, _a, connection, _b, sectionItems_1, sectionItem;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getAppData(useCache)];
                    case 1:
                        appData = _d.sent();
                        sectionItems = [];
                        appMap = new Map();
                        namesMap = new Map();
                        _loop_4 = function (connection) {
                            var data = void 0;
                            data = appData.find(function (config) { return config.id === connection.appId; });
                            if (!data || data.config.hidden === true)
                                return "continue";
                            var app = void 0;
                            // get or make the SectionItem
                            if (!appMap.has(connection.appId)) {
                                app = {
                                    description: data.config.description,
                                    label: data.config.name,
                                    icon: data.config.icon,
                                    selected: this_2.appId === connection.appId,
                                    url: buildProductLaunchUrl(this_2.getPlatformUrl(), connection, this_2.appId === connection.appId && this_2.luParamSupplier
                                        ? this_2.luParamSupplier()
                                        : undefined),
                                };
                                appMap.set(connection.appId, app);
                                sectionItems.push(app);
                            }
                            else {
                                app = appMap.get(connection.appId);
                            }
                            // add the connection name to the list
                            var names = void 0;
                            if (!namesMap.has(connection.appId)) {
                                names = [{
                                        label: connection.name,
                                        url: buildProductLaunchUrl(this_2.getPlatformUrl(), connection, this_2.appId === connection.appId && this_2.luParamSupplier
                                            ? this_2.luParamSupplier()
                                            : undefined),
                                    }];
                                namesMap.set(connection.appId, names);
                            }
                            else {
                                names = namesMap.get(connection.appId);
                                names.push({
                                    label: connection.name,
                                    url: buildProductLaunchUrl(this_2.getPlatformUrl(), connection, this_2.appId === connection.appId && this_2.luParamSupplier
                                        ? this_2.luParamSupplier()
                                        : undefined),
                                });
                                app.appInstances = names;
                            }
                        };
                        this_2 = this;
                        for (_i = 0, _a = (connections !== null && connections !== void 0 ? connections : []); _i < _a.length; _i++) {
                            connection = _a[_i];
                            _loop_4(connection);
                        }
                        // finally, sort the arrays
                        sectionItems.sort(getCompareFunction('label', { ignoreCase: true }));
                        for (_b = 0, sectionItems_1 = sectionItems; _b < sectionItems_1.length; _b++) {
                            sectionItem = sectionItems_1[_b];
                            (_c = sectionItem.appInstances) === null || _c === void 0 ? void 0 : _c.sort(getCompareFunction('label', { ignoreCase: true }));
                        }
                        return [2 /*return*/, [{ sectionItems: sectionItems }]];
                }
            });
        }); });
    };
    PlatformService.prototype.getUserMenuProps = function (userMenuProps, applicationSignOutUrl) {
        var _this = this;
        var _a, _b, _c;
        var menuItems = [];
        var user;
        var token = this.validateAndGetToken();
        if (token) {
            menuItems.push({
                url: this.getPlatformUrl() + '/account/manage',
                label: 'Manage Account'
            });
            var jwtPayload = Authentication_1.default.parseToken(token);
            user = {
                name: (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getFirstName()) + ' ' + (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getLastName()),
                email: (_a = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getEmail()) !== null && _a !== void 0 ? _a : '',
                avatarURL: (_b = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getPicture()) !== null && _b !== void 0 ? _b : ''
            };
        }
        else {
            user = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.user;
        }
        if (token || applicationSignOutUrl) {
            var menuItem = {
                label: 'Sign Out'
            };
            if (token) {
                menuItem.onClick = function (e) {
                    /* We MUST pass the appId as undefined here because we need to redirect to /logout to ensure that
                    a logout happens. */
                    _this.tryRelaunch(true);
                };
            }
            else {
                menuItem.url = applicationSignOutUrl;
            }
            menuItems.push(menuItem);
        }
        ((_c = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.menuItems) !== null && _c !== void 0 ? _c : []).forEach(function (item) {
            if (isPlatformUiAppId(_this.appId) && item.label === 'Billing') {
                menuItems.splice(1, 0, item);
            }
            else {
                menuItems.push(item);
            }
        });
        var signOutElement = menuItems.find(function (element) { return element.label === 'Sign Out'; });
        if (signOutElement) {
            var signOutElementIndex = menuItems === null || menuItems === void 0 ? void 0 : menuItems.indexOf(signOutElement);
            if (signOutElementIndex !== menuItems.length - 1) {
                var divider = {
                    url: '',
                    label: '',
                    divider: true
                };
                menuItems.splice(signOutElementIndex + 1, 0, divider);
            }
        }
        return {
            menuItems: menuItems,
            user: user
        };
    };
    PlatformService.prototype.validateAndGetToken = function () {
        if (!this.token) {
            this.token = getStoredToken(this.lwDomain, this.appId);
        }
        if ((this.token && isTokenExpired(this.token)) || (!this.token && this.lwaOnly)) {
            if (!isPlatformUiAppId(this.appId)) {
                this.tryRelaunch();
            }
            return undefined;
        }
        return this.token;
    };
    PlatformService.prototype.setToken = function (token) {
        storeToken(this.lwDomain, token, this.appId);
        this.token = token;
    };
    PlatformService.prototype.getProductName = function () {
        return this.appName;
    };
    return PlatformService;
}());
exports.default = PlatformService;
